import fetch from '../../../utils/fetch';
import {
    QUESTION_FINISHED_SUCCESS,
    QUESTION_FINISHED_RESET,
} from './mutation-types';
import {QUESTIONS_FINISHED} from '../../../constants/api-routes';

const getDefaultState = () => {
    return {
        unansweredCount: null,
    };
};
const state = getDefaultState();

function success(stats) {
    return {type: QUESTION_FINISHED_SUCCESS, stats};
}

function reset() {
    return {type: QUESTION_FINISHED_RESET};
}

const getters = {
    unansweredCount: state => state.unansweredCount,
};

const actions = {
    retrieve({commit}) {
        commit(reset());
        return fetch(QUESTIONS_FINISHED)
            .then(data => {
                commit(success(data));
            });
    },
};

const mutations = {
    [QUESTION_FINISHED_SUCCESS](state, {stats}) {
        state.unansweredCount = Number(stats.count);
    },
    [QUESTION_FINISHED_RESET](state) {
        Object.assign(state, getDefaultState());
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/question/finished.js